import React from 'react'

import { FormikTabSelect } from 'components/FormikFields'
import { TabItem } from 'components/FormikFields/FormikTabSelect/FormikTabSelect'

interface ConditionTabProps {
    readonly name?: string
    readonly label?: string
    readonly items?: TabItem[]
    readonly prefilled?: boolean
}

const DEFAULT_ITEMS: TabItem[] = [
    { value: 'new', label: 'New' },
    { value: 'used', label: 'Pre-owned' },
]

const defaultProps = {
    name: 'vehicle.condition',
    label: 'Condition',
    items: DEFAULT_ITEMS,
    prefilled: false,
}

export default function ConditionTab({
    name,
    label,
    items,
    prefilled,
}: Readonly<ConditionTabProps>) {
    return (
        <FormikTabSelect
            name={name ?? defaultProps.name}
            label={label ?? defaultProps.label}
            prefilled={prefilled}
        >
            {items ?? defaultProps.items}
        </FormikTabSelect>
    )
}

ConditionTab.defaultProps = defaultProps
